import script from "./PrintDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrintDialog.vue?vue&type=script&lang=ts&setup=true"

import "./PrintDialog.vue?vue&type=style&index=0&id=47d81370&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47d81370"]])

export default __exports__